/** Admin 목록/표시용 순수 함수 (.jsx 밖에 두어 TSX 파서의 `=>` / `>` 오탐 방지) */

export function formatBalance(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "-";
  }

  return numericValue.toLocaleString("ko-KR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
}

export function getReturnRateValue(user) {
  const explicitRate = Number(user.rate_return);
  if (Number.isFinite(explicitRate)) {
    return explicitRate;
  }

  const passUsdt = Number(user.pass_usdt);
  const currentUsdt = Number(user.current_usdt);

  if (!Number.isFinite(passUsdt) || !Number.isFinite(currentUsdt) || passUsdt === 0) {
    return null;
  }

  return Number((((currentUsdt - passUsdt) / passUsdt) * 100).toFixed(2));
}

export function formatRate(rate) {
  if (rate === null || rate === undefined || !Number.isFinite(rate)) {
    return "-";
  }

  const sign = Math.sign(rate) === 1 ? "+" : "";
  return `${sign}${rate.toFixed(2)}%`;
}

export function filterUsersBySearch(users, searchQuery) {
  const q = String(searchQuery ?? "").toLowerCase();

  function matchesSearchValue(value) {
    return String(value ?? "").toLowerCase().includes(q);
  }

  return users.filter(function filterUserBySearch(user) {
    if (matchesSearchValue(user.uid)) {
      return true;
    }
    if (matchesSearchValue(user.uid_2)) {
      return true;
    }
    if (matchesSearchValue(user.nickname)) {
      return true;
    }
    return false;
  });
}
